// extracted by mini-css-extract-plugin
module.exports = {"content":"NewsletterSignUp_content__e6kg0","head":"NewsletterSignUp_head__8CADJ","heading":"NewsletterSignUp_heading__oxanE","subHeading":"NewsletterSignUp_subHeading__V77JT"};